import { CSSProperties } from 'react'

import styles from './Skeleton.module.scss'

export type SkeletonProps = {
	width?: string | number
	height?: string | number
	borderRadius?: string | number
	className?: string
	style?: CSSProperties
}

export const Skeleton = ({
	width = '100%',
	height = '100%',
	borderRadius,
	className,
	style
}: SkeletonProps): JSX.Element => {
	const skeletonStyle: CSSProperties = {
		width: typeof width === 'number' ? `${width}px` : width,
		height: typeof height === 'number' ? `${height}px` : height,
		borderRadius: borderRadius ? (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) : undefined,
		...style
	}

	return <div className={`${styles.skeleton} ${className || ''}`} style={skeletonStyle} />
}
